import {
  ANALYTICS,
  BILLABLE,
  BOOKMARKS,
  DASHBOARD,
  HOME,
  INTEGRATIONS,
  CONTRACT,
  JOB,
  MILESTONE,
  PACKAGE,
  REVENUE,
  SERVICES,
  SURVEY,
} from "icons";
import { ProjectProvider, useProject } from "./context";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/nav/item";
import { NavItemWithBadge } from "@/components/nav/nav-item-with-badge";
import { CollapsibleProjectHeader } from "@/modules/work/projects/components/collapsible-header";
import { ROUTE } from "@/lib/utils";
import { PAGE_BANNER_PORTAL_ID } from "utils";

export default function ProjectLayout(props) {
  return (
    <ProjectProvider>
      <ProjectLayoutContent {...props} />
    </ProjectProvider>
  );
}

function ProjectLayoutContent({ children, ...props }) {
  const {
    data,
    isLoading,
    project_slug,
  } = useProject();

  const projectId = data?.id;

  return (
    <>
      <SidebarProvider
        className="w-fit overflow-hidden max-h-dvh"
        name="project"
      >
        <Sidebar
          collapsible="icon"
          {...props}
          className="sidebar-height border-r bg-red-400 left-auto inset-y-auto top-16"
        >
          <SidebarHeader className="p-0">
            <CollapsibleProjectHeader project={data} isLoading={isLoading} />
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                <NavItem
                  title="Dashboard"
                  icon={DASHBOARD}
                  url={ROUTE.PROJECT(project_slug)}
                  matchExact={true}
                />
                <NavItemWithBadge
                  title="Contracts"
                  icon={CONTRACT}
                  url={ROUTE.PROJECT_CONTRACTS(project_slug)}
                  collection={projectId ? "contracts" : undefined}
                  filters={{ project: { _eq: projectId }, status: { _eq: "in_progress" } }}
                  requiredPermissions={{
                    type: "collection",
                    collection: "contracts",
                  }}
                />
                <NavItemWithBadge
                  title="Jobs"
                  icon={JOB}
                  url={ROUTE.PROJECT_JOBS(project_slug)}
                  collection={projectId ? "jobs" : undefined}
                  filters={{ project: { _eq: projectId }, status: { _eq: "in_progress" } }}
                />
                <NavItemWithBadge
                  title="Billables"
                  icon={BILLABLE}
                  url={ROUTE.PROJECT(project_slug) + "/billables"}
                  collection={projectId ? "billables" : undefined}
                  filters={{ job: { project: { _eq: projectId } }, status: { _nin: ["collected", "cancelled", "archived"] } }}
                  requiredPermissions={{
                    type: "collection",
                    collection: "billables",
                  }}
                />
                <NavItemWithBadge
                  title="Milestones"
                  icon={MILESTONE}
                  url={ROUTE.PROJECT_MILESTONES(project_slug)}
                  collection={projectId ? "milestones" : undefined}
                  filters={{ job: { project: { _eq: projectId } }, status: { _eq: "in_progress" } }}
                />
                <NavItem
                  title="Bookmarks"
                  icon={BOOKMARKS}
                  url={ROUTE.PROJECT_BOOKMARKS(project_slug)}
                />
                <NavItem
                  title="Deliverables"
                  icon={PACKAGE}
                  url={ROUTE.PROJECT_DELIVERABLES(project_slug)}
                />
                <NavItem
                  title="Integrations"
                  icon={INTEGRATIONS}
                  url={ROUTE.PROJECT_INTEGRATIONS(project_slug)}
                />
                <NavItem
                  title="Revenue"
                  icon={REVENUE}
                  url={ROUTE.PROJECT_REVENUE(project_slug)}
                />
                {/* <NavItem
                  title="Services"
                  icon={SERVICES}
                  url={ROUTE.PROJECT_SERVICES(project_slug)}
                /> */}
                {/* <PermissionGate rules={["update:PC,Admin"]} collection="projects" fallback={<></>}> */}
                {/* <NavItem
                  title="Analytics"
                  icon={ANALYTICS}
                  url={ROUTE.PROJECT_ANALYTICS(project_slug)}
                // rule="read:PC"
                // collection="projects"
                /> */}
                <NavItem
                  title="Surveys"
                  icon={SURVEY}
                  url={ROUTE.PROJECT_SURVEYS(project_slug)}
                  requiredPermissions={{
                    type: "collection",
                    collection: "surveys",
                  }}
                />
                {/* </PermissionGate> */}
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarRail />
        </Sidebar>
      </SidebarProvider>

      <div className="flex flex-1 flex-col min-w-0">
        {/* Page-level banners (portaled in); collapses when empty. */}
        <div
          id={PAGE_BANNER_PORTAL_ID}
          className="flex flex-col gap-2 px-4 pt-4 empty:hidden"
        />
        {children}
      </div>
    </>
  );
}
